var rich_content_viewer_default = {
  "fontElementMap": "Jj-ce",
  "wrapper": "_51bfW",
  "pluginContainerMobile": "AHsN1",
  "viewer": "Z9NRM",
  "android": "f20Gz",
  "rootedTraversedContent": "XM1-r",
  "atomic": "oHsIv",
  "toolbar": "b-1Sh",
  "block": "JKIfS"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
